<template>
  <div>
    <b-modal
      id="modal-scrollable"
      v-model="$store.state.someVariables.showModalLog"
      scrollable
      no-close-on-backdrop
      title="Detalle Log"
      cancel-variant="outline-secondary"
    >
      <div v-if="dataLog != null">
        <div v-if="dataLog.tipo_dato == 'sancion'">
          <div><b>Data antigua</b></div>
          <div v-for="item in dataLog.partidos.antiguos" :key="item.id">
            {{ item }}
          </div>
          <br>
          <div><b>Data nueva</b></div>
          <div v-for="item in dataLog.partidos.nueva" :key="item.id">
            {{ item }}
          </div>
        </div>
      </div>
    </b-modal>
  </div>
</template>
<script>
export default {
  props: {
    dataLog: Object,
  },
  setup() {},
}
</script>
